import { Divider, Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';
import Colors from 'configs/Colors';

import useReadNotification from '../hooks/useReadNotification';

const NotificationHeader = ({ notifications }) => {
  const { t } = useTranslation();

  const { mutate: readNotification } = useReadNotification();

  const handleMarkAllAsRead = (e) => {
    e.stopPropagation();
    const unreadNotifications = notifications?.filter((n) => !n.is_read) || [];
    unreadNotifications.forEach((notification) => {
      readNotification(notification.id);
    });
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{ justifyContent: 'space-between' }}
      >
        <Text fontWeightBold>{t('all_notifications')}</Text>
        <Text
          fontWeightBold
          color={Colors.Blue6}
          onClick={handleMarkAllAsRead}
          style={{ cursor: 'pointer' }}
        >
          {t('mark_all_as_read')}
        </Text>
      </Stack>

      <Divider sx={{ mt: 2 }} />
    </>
  );
};

export default NotificationHeader;
